import styled from "styled-components";

export const StyledActor = styled.div`
  font-family: "Abel", sans-serif;
  color: #fff;
  background: #1c1c1c;
  border-radius: 20px;
  transition: all 0.3s;
  padding: 5px;
  overflow: hidden;
  text-align: center;
  &:hover {
    transform: scale(1.03);
  }

  img {
    display: block;
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 15px;

    transition: all 3s ease-in-out;
    &:hover {
      transform: scale(1.1);
    }
  }

  .actor-name {
    display: block;
    font-size: 18px;
    margin: 10px 0 0 0;
  }

  .actor-character {
    display: block;
    font-size: 16px;
    margin: 0 0 10px 0;
  }
`;
